import type { IItemDto } from '../../inventory/item-dto.interface';

/** Labeled reward line from TF reward-preview / grant responses. */
export enum TfRewardKind {
  completion = 'completion',
  flowerBonus = 'flowerBonus'
}

export interface TfRewardLine {
  kind: TfRewardKind;
  itemId: string;
  count: number;
  itemInfo: IItemDto;
}

/** REST reward-preview / player-exit response body for one player. */
export interface TfRewardResponse {
  playerId: string;
  rewards: TfRewardLine[];
}

/** REST game-matches/end response for Terraforming. */
export interface TfMatchEndResponse {
  matchEndPlayerResults: TfRewardResponse[];
}

/** AGE → RE socket payload for `tfRewardPreview`. */
export interface TfRewardPreviewNotify {
  rewards: TfRewardLine[];
}

/**
 * AGE → RE socket payload for `tfPlayerExitResult`.
 * originalRewards is the grass-goal preview slate (empty if preview never cached).
 */
export interface TfPlayerExitNotify {
  rewards: TfRewardLine[];
  originalRewards: TfRewardLine[];
}
